import { Component, output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { InputText } from '@openng/optimus-ui/inputtext';
import { ButtonDirective } from '@openng/optimus-ui/button';

@Component({
  selector: 'app-region-mobile-filter',
  templateUrl: './region-mobile-filter.component.html',
  styleUrls: ['./region-mobile-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslateDirective,
    FormsModule,
    InputText,
    ButtonDirective,
    TranslatePipe,
  ],
})
export class RegionMobileFilterComponent {
  readonly mobileFilterEvent = output<any>();

  name: string | null = null;
  owner: string | null = null;
  contactList: string | null = null;
  areas: string | null = null;

  mobileFilter() {
    this.mobileFilterEvent.emit({
      name: this.name,
      owner: this.owner,
      contactList: this.contactList,
      areas: this.areas,
    });
  }

  clear() {
    this.name = null;
    this.owner = null;
    this.contactList = null;
    this.areas = null;
    this.mobileFilter();
  }
}
